import { render, staticRenderFns } from "./LinkTenantSettingTemplate.vue?vue&type=template&id=4049195a&scoped=true"
import script from "./LinkTenantSettingTemplate.vue?vue&type=script&lang=js"
export * from "./LinkTenantSettingTemplate.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSettingTemplate.vue?vue&type=style&index=0&id=4049195a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4049195a",
  null
  
)

export default component.exports